"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var mapFaq = function mapFaq(response) {
  if (!response) return false;
  return {
    content: response.data.body.map(function (question) {
      return {
        question: question.items && question.items[0].question[0].text,
        answer: question.items && question.items[0].answer
      };
    })
  };
};
var _default = mapFaq;
exports["default"] = _default;